export const DEFAULT_FACET_TYPE = 'valueId';
export * from './experiences/types.js';
